import { Text, Styled } from "theme-ui";
import { AboutMe } from "../../../../src/components/about-me";
import * as React from 'react';
export default {
  Text,
  Styled,
  AboutMe,
  React
};